import React from 'react';
import { Line } from 'react-konva';
import { relatedColor, unrelatedColor, lineCap, strokeWidth } from '../../library/constants';

const HandleComponent = ( {xHandlePos, startYOfHandle, endYOfHandle, unionIsRelated, atLeastOneChildRelated, unionColor, stageBackgroundCustomColor} ) => {
  const coordinates = [xHandlePos, startYOfHandle, xHandlePos, endYOfHandle];

  const getUnrelatedColor = () => {
    return typeof(unionColor) !== 'undefined' ? unionColor : unrelatedColor;
  }

  let color = ( unionIsRelated || atLeastOneChildRelated ? relatedColor: getUnrelatedColor());
  color = typeof(stageBackgroundCustomColor) !== 'undefined' && stageBackgroundCustomColor === '#000000' ? '#FFFFFF': color;

  return (
    <Line
      points = {coordinates}
      stroke = {color}
      strokeWidth = {strokeWidth}
      lineCap = {lineCap}
      perfectDrawEnabled={false}
      listening={false}
    />
  );
};

export default HandleComponent;
